var breakpoint = 768
var isOverBreakpoint = false
var tabs = null

document.addEventListener('DOMContentLoaded', function () {
  tabs = document.querySelector('.tabs--vertical')
  if (!tabs || tabs.length === 0) {
    return
  }
  init()
  window.addEventListener(
    'resize',
    debounce(function (e) {
      if (window.innerWidth >= breakpoint && !isOverBreakpoint) {
        init()
        isOverBreakpoint = true
      } else if (window.innerWidth < breakpoint && isOverBreakpoint) {
        init()
        isOverBreakpoint = false
      }
    })
  )
})

function debounce(func) {
  var timer
  return function (event) {
    if (timer) clearTimeout(timer)
    timer = setTimeout(func, 100, event)
  }
}

function init() {
  console.log('init')

  if (tabs.classList.contains('scroll-capture')) {
    initScrollCapture()
  } else {
    initSimpleCssAnimation()
  }
}

function initSimpleCssAnimation() {
  if (window.innerWidth >= breakpoint) {
    initAsTabs()
  } else {
    initAsSlider()
  }
}

function initAsTabs() {
  ;[tabs].forEach(function (tab) {
    var nav = tab.querySelector('.tabs__nav')
    var navItems = nav.querySelectorAll('a')
    var panels = tab.querySelector('.tabs__content')
    var panelBacks = panels.querySelectorAll('.tab-panel-background')
    var panelItems = panels.querySelectorAll('.tab-panel')

    navItems.forEach(function (navItem, index) {
      navItem.addEventListener('click', function (e) {
        e.preventDefault()
        navItems.forEach(function (navItem) {
          navItem.classList.remove('active')
        })
        navItem.classList.add('active')

        panelBacks.forEach(function (panelBack) {
          panelBack.classList.remove('active')
        })
        panelBacks[index].classList.add('active')

        panelItems.forEach(function (panelItem) {
          panelItem.classList.remove('active')
        })
        panelItems[index].classList.add('active')
      })
    })
  })
}

function initAsSlider() {
  console.log('init slider')

  var currentTabIndex = 0

  ;[tabs].forEach(function (tab) {
    var nav = tab.querySelector('.tabs__nav')
    var navItems = nav.querySelectorAll('a')
    var panels = tab.querySelector('.tabs__content')
    var panelBacks = panels.querySelectorAll('.tab-panel-background')

    jQuery('.tabs__content__panels', tab).slick({
      arrows: false,
      dots: true,
    })
    jQuery('.tabs__content__panels', tab).on('afterChange', function (event, slick, currentSlide) {
      if (currentTabIndex !== currentSlide) {
        setNavItem(currentSlide)
        setBackground(currentSlide)
        currentTabIndex = currentSlide
      }
    })

    navItems.forEach(function (navItem, index) {
      navItem.addEventListener('click', function (e) {
        e.preventDefault()
        jQuery('.tabs__content__panels').slick('slickGoTo', index)
        setNavItem(index)
        setBackground(index)
        currentTabIndex = index
      })
    })

    function setNavItem(index) {
      navItems.forEach(function (navItem) {
        navItem.classList.remove('active')
      })
      navItems[index].classList.add('active')
    }

    function setBackground(index) {
      panelBacks.forEach(function (panelBack) {
        panelBack.classList.remove('active')
      })
      panelBacks[index].classList.add('active')
    }
  })
}

function initScrollCapture() {
  if (window.innerWidth >= breakpoint) {
    initAsScrollCapture()
  } else {
    clearScrollCapture()
    initAsSlider()
  }
}

var tl, sc

function initAsScrollCapture() {
  console.log('init scroll capture')
  gsap.registerPlugin(ScrollTrigger)

  tl = gsap.timeline({})
  var container = document.querySelector('.page-section__vertical-tabs.scroll-capture')
  var tabs = container.querySelectorAll('.tabs__content__panels .tab-panel')
  var navItems = container.querySelectorAll('.tabs__nav a')

  var height = container.offsetHeight
  var duration = 0.2
  var delay = 0.3

  navItems.forEach(function (navItem, index) {
    navItem.addEventListener('click', function (e) {
      //e.preventDefault()
      //gsap.to(window, { duration: 2, scrollTo: { y: '#tab-' + (index + 1), offsetY: 100 }, ease: 'power2.inOut' })
      // gsap.to(window, {
      //   duration: 2,
      //   scrollTo: { x: 0, y: y + h * (index + 1) },
      // })

      gsap.to(window, {
        scrollTo: tl.scrollTrigger.labelToScroll('tab-' + (index + 1)),
        ease: 'bounce.out',
        duration: 0.2,
      })
    })
  })

  tabs.forEach(function (tab, index) {
    var item = index + 1
    if (index > 0) {
      tl.from('#tab-' + item + ' header', { y: '100%', opacity: 0, duration })
      tl.from('#tab-bg-' + item, { opacity: 0, duration }, '<')
      tl.from(
        '#tab-' + item + ' .content__inner',
        {
          x: '100%',
          opacity: 0,
          duration,
          onStart: () => {
            console.log('start ' + index)
            navItems.forEach(function (navItem) {
              navItem.classList.remove('active')
            })
            navItems[index].classList.add('active')
          },
          onRepeat: () => {
            console.log('repeat ' + index)
          },
        },
        '<'
      )
    }
    tl.addLabel('tab-' + item)
    if (index < tabs.length - 1) {
      tl.to('#tab-' + item + ' header', { y: '-100%', opacity: 1, duration, delay })
      tl.to('#tab-bg-' + item, { opacity: 1, duration }, '<')
      tl.to(
        '#tab-' + item + ' .content__inner',
        {
          x: '-100%',
          opacity: 0,
          duration,
          onComplete: () => {
            console.log('complete ' + index)
            //navItems[index].classList.remove('active')
          },
          onReverseComplete: () => {
            console.log('reverse complete ' + index)
            navItems.forEach(function (navItem) {
              navItem.classList.remove('active')
            })
            index >= 0 && navItems[index].classList.add('active')
          },
        },
        '<'
      )
    }
  })

  sc = ScrollTrigger.create({
    animation: tl,
    trigger: '.page-section__vertical-tabs',
    start: 'center center',
    end: '+=' + height * tabs.length,
    //markers: true,
    scrub: 1,
    pin: true,
    toggleActions: 'restart none reverse reset',
    onToggle: (self) => console.log('toggled, isActive:', self),
    snap: {
      snapTo: 'labels', // snap to the closest label in the timeline
      duration: { min: 0.1, max: 1 }, // the snap animation should be at least 0.2 seconds, but no more than 3 seconds (determined by velocity)
      delay: 0.2, // wait 0.2 seconds from the last scroll event before doing the snapping
      //ease: 'power1.inOut', // the ease of the snap animation ("power3" by default)
    },
  })
}

function clearScrollCapture() {
  console.log('clear')
  try {
    gsap.to('*', { clearProps: true })
    tl.kill()
    sc.kill()
  } catch (e) {
    //console.log(e)
  }
}
